import React, { useState } from "react";
import "../../pages/doctor-console/DoctorConsole.scss";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton, 
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import { Icon, TableHead } from "@mui/material";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import { AttachmentActionButtons, ModalActionButtons } from "../../pages/doctor-console/Utils/AttachmentActions";
import {
  formatDateIST,
  separateCamelCase,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";

const ImmunizationRecord = (props) => {
  const collapseByDefault = props.collapseByDefault;
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const immunizationData = props.immunizationData;
  console.log("Immunization Records", immunizationData);
  const viewAttachment = (attach) => {
    let attachment = attach.content[0];
    setCurrentAttachment(attachment);
    console.log("Immunization Attachment", attachment);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (
      attachment.content_type === "application/pdf" ||
      attachment.content_type === "pdf"
    ) {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  return (
    <>
      <DoctorconsoleGrid>
        {immunizationData !== undefined && immunizationData !== null ? (
          <>
            <HiTypeHeader
              date={immunizationData.Date}
              name={"Immunization Record"}
              encounter={immunizationData.Encounter}
              organizationDetails={immunizationData.Organization}
              practitionerDetails={immunizationData.Practitioner}
            />
            {Object.keys(immunizationData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) && (
                  <Accordion className="innermost-accordion" defaultExpanded={!collapseByDefault}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Row
                        style={{
                          marginTop: "30px",
                          // backgroundImage:
                          //   "url('../../assets/images/backgrounds/2.jpg')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Col
                          area="span 12"
                          style={{ border: "2px solid #76787a" }}
                        >
                          {categoryKey.includes("DocumentReference") ? (
                            <div
                              style={{
                                marginTop: "20px",
                                fontWeight: "bold",
                                marginBottom: "50px",
                                fontSize: "16px",
                              }}
                            >
                              Attachments :{" "}
                              {immunizationData[categoryKey].length > 0
                                ? immunizationData[categoryKey].map(
                                    (attachment, attIdx) => {
                                      return (
                                        <span
                                          key={attIdx}
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            marginRight: "12px",
                                          }}
                                        >
                                          <button
                                            style={{
                                              backgroundColor: "#007bff",
                                              color: "#fff",
                                              border: "none",
                                              padding: "5px 10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              viewAttachment(attachment)
                                            }
                                          >
                                            {" "}
                                            {/* Click here to see{" "} */}
                                            <i className="fas fa-file"></i>
                                          </button>
                                          <AttachmentActionButtons
                                            base64Data={
                                              attachment?.content?.[0]?.data
                                            }
                                            contentType={
                                              attachment?.content?.[0]
                                                ?.content_type
                                            }
                                            filename={
                                              attachment?.id || "attachment"
                                            }
                                          />
                                        </span>
                                      );
                                    }
                                  )
                                : "No attachments found!"}
                            </div>
                          ) : (
                            <Table responsive size="lg">
                              <TableHead
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  gridTemplateColumns:
                                    "250px 250px 250px 120px 120px",
                                  justifyContent: "center",
                                }}
                              >
                                {/* Define table headers based on category */}
                                {categoryKey.includes("Immunization") ? (
                                  <>
                                    <td>Name</td>
                                    <td>Lot Number</td>
                                    <td>Manufacturer</td>
                                    <td>Dose No</td>
                                    <td>Immunization Date</td>
                                  </>
                                ) : categoryKey.includes(
                                    "ImmunizationRecommendation"
                                  ) ? (
                                  <>
                                    <td>Name</td>

                                    <td>Status</td>
                                    <td>Description</td>
                                  </>
                                ) : null}
                              </TableHead>
                              <tbody>
                                {/* Render rows for each item within the category */}
                                {immunizationData?.[categoryKey].map((item) => (
                                  <tr key={item.id}>
                                    {" "}
                                    {/* Add a unique key for each row */}
                                    {/* Render cells based on category */}
                                    {categoryKey.includes("Immunization") ? (
                                      <>
                                        <td>
                                          {item?.code?.[0]?.display
                                            ? item.code[0].display
                                            : item.code[0]}
                                        </td>
                                        <td>{item?.lot_number ?? "-"}</td>
                                        <td>
                                          {item?.manufacturer?.name ?? "-"}
                                        </td>
                                        <td>
                                          {item?.protocol_applied
                                            ?.doseNumberInt ?? "-"}
                                        </td>
                                        <td>
                                          {item.immunization_date &&
                                          item.immunization_date !== ""
                                            ? formatDateIST(
                                                item.immunization_date
                                              )
                                            : "-"}
                                        </td>
                                      </>
                                    ) : categoryKey.includes(
                                        "ImmunizationRecommendation"
                                      ) ? (
                                      <>
                                        <td>
                                          {Array.isArray(item?.code) &&
                                          item.code.length > 0
                                            ? typeof item.code[0] === "object"
                                              ? item.code[0]?.display ?? "-"
                                              : item.code[0] ?? "-"
                                            : "-"}
                                        </td>

                                        <td>
                                          {Array.isArray(
                                            item?.forecast_status_coding
                                          ) &&
                                          item.forecast_status_coding.length > 0
                                            ? typeof item
                                                .forecast_status_coding[0] ===
                                              "object"
                                              ? item.forecast_status_coding[0]
                                                  ?.display ?? "-"
                                              : item
                                                  .forecast_status_coding[0] ??
                                                "-"
                                            : "-"}
                                        </td>

                                        <td>{item?.description ?? "-"}</td>
                                      </>
                                    ) : null}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </Col>
                      </Row>
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Discharge Summary found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
              padding: "8px 12px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {currentAttachment && (
              <ModalActionButtons
                base64Data={currentAttachment.data}
                contentType={currentAttachment.content_type}
                filename="attachment"
              />
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};

export default ImmunizationRecord;
